;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="5cfb47d2-eb69-46ef-a421-b76bd103d472",e._sentryDebugIdIdentifier="sentry-dbid-5cfb47d2-eb69-46ef-a421-b76bd103d472")}catch(e){}}();
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2270],{

/***/ 62270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./src/components/mycourses/LearningResource.tsx
var LearningResource = __webpack_require__(61193);
// EXTERNAL MODULE: ./src/components/user-guide/PopupStep.tsx
var PopupStep = __webpack_require__(70742);
// EXTERNAL MODULE: ./src/utils/google-analytics.ts
var google_analytics = __webpack_require__(72158);
// EXTERNAL MODULE: ./src/constants/index.ts + 4 modules
var constants = __webpack_require__(43743);
// EXTERNAL MODULE: ./src/redux/hook.ts
var hook = __webpack_require__(34705);
// EXTERNAL MODULE: ./src/redux/slice/Course/UserGuide.tsx
var UserGuide = __webpack_require__(87642);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(37559);
// EXTERNAL MODULE: ./src/constants/lang.ts
var lang = __webpack_require__(66190);
;// CONCATENATED MODULE: ./src/constants/menu-items.ts




var MENU_OPTIONS = [
    {
        name: "".concat(constants/* TitleSidebar.DASHBOARD */.ci.DASHBOARD),
        icon: "grid",
        url: constants/* PageLink.DASHBOARD */.H_.DASHBOARD,
        type: "level-1"
    },
    {
        name: "".concat(constants/* TitleSidebar.COURSES */.ci.COURSES),
        icon: "course",
        url: "".concat(constants/* PageLink.COURSES */.H_.COURSES),
        type: "level-1"
    },
    {
        name: "".concat(constants/* TitleSidebar.COURSE_CONTENT */.ci.COURSE_CONTENT),
        icon: "bookmark",
        url: "".concat(constants/* PageLink.COURSE_CONTENT */.H_.COURSE_CONTENT),
        type: "level-2"
    },
    {
        name: "".concat(constants/* TitleSidebar.NOTES_LIST */.ci.NOTES_LIST),
        icon: "notes-list",
        url: "#",
        type: "level-1"
    },
    {
        name: "".concat(constants/* TitleSidebar.RESOURCES */.ci.RESOURCES),
        icon: "learning-resource",
        url: "#",
        type: "level-1"
    },
    {
        name: "".concat(constants/* TitleSidebar.ENTRANCE_TEST */.ci.ENTRANCE_TEST),
        icon: "entrance-test",
        url: "".concat(constants/* PageLink.ENTRANCE_TEST */.H_.ENTRANCE_TEST),
        type: "level-1"
    },
    {
        name: "".concat(constants/* TitleSidebar.RESULTS */.ci.RESULTS),
        icon: "result",
        url: constants/* PageLink.RESULTS */.H_.RESULTS,
        type: "level-2"
    },
    {
        name: "".concat(constants/* TitleSidebar.EXAM_INFORMATION */.ci.EXAM_INFORMATION),
        icon: "exam_information",
        url: "#",
        type: "level-2"
    },
    {
        name: "".concat(constants/* TitleSidebar.NEW_NOTE */.ci.NEW_NOTE),
        icon: "create-note",
        url: "#",
        type: "level-1"
    },
    {
        name: "".concat(constants/* TitleSidebar.CALCULATOR */.ci.CALCULATOR),
        icon: "caculator",
        url: "#",
        type: "level-1"
    },
    {
        name: constants/* TitleSidebar.CALENDAR */.ci.CALENDAR,
        icon: "calendar",
        url: constants/* PageLink.CALENDAR */.H_.CALENDAR,
        type: "level-1"
    }, 
];
var MENU_OPTIONS_EVENTTEST = [
    {
        name: lang/* LANG_SIGNIN.eventTest */.ZD.eventTest,
        icon: "event-test",
        url: constants/* PageLink.EVENT_TEST */.H_.EVENT_TEST,
        type: "level-1"
    }, 
];
var MENU_OPTIONS_BOTTOM = [
    {
        name: "".concat(constants/* TitleSidebar.NOTIFICATION */.ci.NOTIFICATION),
        icon: "notification",
        url: "".concat(constants/* PageLink.NOTIFICATION */.H_.NOTIFICATION),
        type: "level-1"
    },
    {
        name: "",
        icon: "avatar",
        url: "".concat(constants/* PageLink.MYPROFILE */.H_.MYPROFILE),
        type: "level-1"
    },
    {
        name: "",
        icon: "profile-detail",
        url: "".concat(constants/* PageLink.MYPROFILE */.H_.MYPROFILE),
        type: "level-1"
    }, 
];
function makeMenuLevel(options) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return options.map(function(option, idx) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option), {
            id: depth === 0 ? idx.toString() : "".concat(depth, ".").concat(idx),
            depth: depth,
            subItems: option.subItems && option.subItems.length > 0 ? makeMenuLevel(option.subItems, depth + 1) : undefined
        });
    });
}
var MENU_ITEMS = makeMenuLevel(MENU_OPTIONS);
var MENU_ITEMS_EVENT = makeMenuLevel(MENU_OPTIONS_EVENTTEST);
var MENU_BOTTOM = makeMenuLevel(MENU_OPTIONS_BOTTOM);

// EXTERNAL MODULE: ./src/components/layout/ExpandIcon/index.tsx + 4 modules
var ExpandIcon = __webpack_require__(6675);
// EXTERNAL MODULE: ./src/assets/images/blank_avatar.webp
var blank_avatar = __webpack_require__(57213);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(60071);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(12691);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(34376);
// EXTERNAL MODULE: ./src/redux/slice/Course/MyCourse/Activity/Activity.ts
var Activity = __webpack_require__(57304);
// EXTERNAL MODULE: ./src/redux/slice/Course/NotesList.tsx
var NotesList = __webpack_require__(92231);
// EXTERNAL MODULE: ./src/redux/slice/User/User.tsx
var User = __webpack_require__(85195);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(55402);
;// CONCATENATED MODULE: ./src/components/layout/MenuItem/index.tsx
















function MenuItem(param) {
    var _menuItem = param.menuItem, name = _menuItem.name, Icon = _menuItem.icon, url = _menuItem.url, type = _menuItem.type, subItems = _menuItem.subItems, setOpenResource = param.setOpenResource, closeSideBar = param.closeSideBar;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,react.useState)(false), isExpanded = ref10[0], toggleExpanded = ref10[1];
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var user = (0,hook/* useAppSelector */.C)(User/* userReducer */.M3).user;
    var router = (0,next_router.useRouter)();
    var isNested = subItems && (subItems === null || subItems === void 0 ? void 0 : subItems.length) > 0;
    var selected = router.pathname === url;
    var onClick = function() {
        toggleExpanded(function(prev) {
            return !prev;
        });
    };
    var handleOpenResource = function() {
        setOpenResource && setOpenResource(true);
        document.body.style.overflow = "hidden";
    };
    var handleOpenNotesList = function() {
        dispatch((0,NotesList/* activeNotesList */.pD)());
        document.body.style.overflow = "hidden";
    };
    var handleAddNote = function() {
        var note = {
            uuid: (0,v4/* default */.Z)(),
            id: "",
            name: "Note",
            description: ""
        };
        dispatch((0,NotesList/* pushNotes */.xT)(note));
    };
    var handleOpenCalculator = function() {
        dispatch((0,Activity/* openCalculator */.Gp)());
    };
    var handleOpenResultsPage = function() {
        router.push({
            pathname: "/courses/my-course/".concat(router.query.courseId || router.query.id, "/results")
        });
    };
    var handleOpenExaminationInfoPage = function() {
        router.push({
            pathname: "/courses/my-course/".concat(router.query.courseId || router.query.id, "/exam-information")
        });
    };
    var handleActive = function() {
        var ref;
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.courseId) || router.query.id) {
            name === constants/* TitleSidebar.RESOURCES */.ci.RESOURCES && handleOpenResource();
            name === constants/* TitleSidebar.NOTES_LIST */.ci.NOTES_LIST && handleOpenNotesList();
            name === constants/* TitleSidebar.NEW_NOTE */.ci.NEW_NOTE && handleAddNote();
            name === constants/* TitleSidebar.CALCULATOR */.ci.CALCULATOR && handleOpenCalculator();
            name === constants/* TitleSidebar.RESULTS */.ci.RESULTS && handleOpenResultsPage();
            name === constants/* TitleSidebar.EXAM_INFORMATION */.ci.EXAM_INFORMATION && handleOpenExaminationInfoPage();
        }
    };
    var isActivity = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.activityId;
    var isInCourse = (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.courseId) || (router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.activityId) || (router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.course_section_id);
    var checkIsHiddenDashboard = function(info) {
        return name == constants/* TitleSidebar.DASHBOARD */.ci.DASHBOARD && !info;
    };
    var renderMenuContent = function() {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center",
            onClick: handleActive,
            children: [
                Icon === "avatar" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-10 w-10 shrink-0",
                    children: (user === null || user === void 0 ? void 0 : (ref = user.detail) === null || ref === void 0 ? void 0 : ref.avatar["40x40"]) || user.detail.avatar["ORIGIN"] ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: user.detail.avatar["40x40"] || user.detail.avatar["ORIGIN"],
                        alt: "avatar",
                        className: "h-10 w-10 rounded-full object-cover",
                        width: 40,
                        height: 40
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: blank_avatar/* default */.Z,
                        alt: "avatar",
                        className: "rounded-full",
                        width: 40,
                        height: 40,
                        priority: true
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: Icon === "profile-detail" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-10 w-10 shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: user.detail.avatar["40x40"] || user.detail.avatar["ORIGIN"] || blank_avatar/* default */.Z,
                            alt: "avatar",
                            className: "h-10 w-10 rounded-full object-cover",
                            width: 40,
                            height: 40,
                            priority: true
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandIcon/* default */.Z, {
                        type: Icon,
                        className: "before-icon min-h-6 min-w-6 shrink-0 ".concat(selected ? "text-primary" : "text-gray-2", " group-hover:text-primary \n                ")
                    })
                }),
                Icon === "avatar" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "label avatar invisible pl-4 text-base font-normal opacity-0 transition-all duration-150 ".concat(selected ? "text-primary" : "text-gray-2", " group-hover:text-primary"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line-clamp-1 text-base font-semibold text-bw-1 group-hover:text-primary",
                            children: user === null || user === void 0 ? void 0 : (ref1 = user.detail) === null || ref1 === void 0 ? void 0 : ref1.full_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line-clamp-1 text-medium-sm font-normal capitalize text-gray-1 group-hover:text-primary",
                            children: user === null || user === void 0 ? void 0 : (ref2 = user.type) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: Icon === "profile-detail" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "label invisible line-clamp-1 pl-4 text-base font-normal opacity-0 transition-all duration-150 ".concat(selected ? "text-primary" : "text-gray-2", " group-hover:text-primary"),
                        children: user === null || user === void 0 ? void 0 : (ref3 = user.detail) === null || ref3 === void 0 ? void 0 : ref3.full_name
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "label invisible line-clamp-1 pl-4 text-base font-normal opacity-0 transition-all duration-150 ".concat(selected ? "text-primary" : "text-gray-2", " group-hover:text-primary"),
                        onClick: function() {
                            return (0,google_analytics/* trackGAEvent */.wu)("Click Button ".concat(name, " Menu "));
                        },
                        children: name
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isActivity && name === constants/* TitleSidebar.NEW_NOTE */.ci.NEW_NOTE && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto h-px w-[calc(100%-48px)] bg-gray-2 text-center"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "group cursor-pointer hover:bg-secondary ".concat(selected && (type === "level-1" && Icon !== "avatar" && Icon !== "profile-detail" || type === "level-2" && Icon === "result") ? "border-l-4 border-active pl-6 pr-1" : "pl-7", " sidebar-list-items relative mb-4 py-2 last:mb-0 ").concat(!isActivity && (name === constants/* TitleSidebar.NEW_NOTE */.ci.NEW_NOTE || name === constants/* TitleSidebar.CALCULATOR */.ci.CALCULATOR) ? "hidden" : name === constants/* TitleSidebar.NEW_NOTE */.ci.NEW_NOTE ? "mt-4" : "", "\n        ").concat(!isInCourse && (name === constants/* TitleSidebar.COURSE_CONTENT */.ci.COURSE_CONTENT || name === constants/* TitleSidebar.NOTES_LIST */.ci.NOTES_LIST || name === constants/* TitleSidebar.RESOURCES */.ci.RESOURCES || name === constants/* TitleSidebar.RESULTS */.ci.RESULTS || name === constants/* TitleSidebar.EXAM_INFORMATION */.ci.EXAM_INFORMATION || name === constants/* TitleSidebar.DASHBOARD */.ci.DASHBOARD || Icon === "stats-chart-sharp" || Icon === "profile-detail") ? "hidden" : "", "\n        ").concat(isInCourse && (name === constants/* TitleSidebar.COURSES */.ci.COURSES || name === constants/* TitleSidebar.ENTRANCE_TEST */.ci.ENTRANCE_TEST || // hidden when not in course
                name === lang/* LANG_SIGNIN.eventTest */.ZD.eventTest || checkIsHiddenDashboard(JSON.parse(localStorage.getItem("courseInfo"))) || Icon === "avatar") ? "hidden" : "", "\n        "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sidebar-item flex max-h-[24px]  items-center ".concat(Icon === "avatar" || Icon === "profile-detail" ? "-ml-2" : ""),
                        onClick: function() {
                            return closeSideBar();
                        },
                        children: [
                            url !== "#" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: url === constants/* PageLink.RESULTS */.H_.RESULTS ? "/courses/my-course/".concat((router === null || router === void 0 ? void 0 : (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.courseId) || (router === null || router === void 0 ? void 0 : (ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.id), "/results") : url === constants/* PageLink.DASHBOARD */.H_.DASHBOARD ? "/courses/my-course/".concat((router === null || router === void 0 ? void 0 : (ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.courseId) || (router === null || router === void 0 ? void 0 : (ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.id), "/dashboard") : name === constants/* TitleSidebar.COURSE_CONTENT */.ci.COURSE_CONTENT ? "".concat(url, "/").concat((router === null || router === void 0 ? void 0 : (ref8 = router.query) === null || ref8 === void 0 ? void 0 : ref8.courseId) || (router === null || router === void 0 ? void 0 : (ref9 = router.query) === null || ref9 === void 0 ? void 0 : ref9.id)) : url,
                                passHref: true,
                                children: renderMenuContent()
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: renderMenuContent()
                            }),
                            isNested && type === "level-2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandIcon/* default */.Z, {
                                isExpanded: isExpanded,
                                handleClick: onClick,
                                type: "ontoggle",
                                className: "".concat(selected ? "text-primary" : "", " group-hover:text-primary")
                            }) : null
                        ]
                    }),
                    isNested ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sidebar-child ".concat(type, " ").concat(isExpanded && type === "level-2" ? "active" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemsList, {
                            options: subItems,
                            setOpenResource: setOpenResource,
                            closeSideBar: closeSideBar
                        })
                    }) : null
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/layout/MenuItemsList/index.tsx


function MenuItemsList(param) {
    var options = param.options, setOpenResource = param.setOpenResource, closeSideBar = param.closeSideBar;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "menu-items-list",
        children: options.map(function(option, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                menuItem: option,
                setOpenResource: setOpenResource,
                closeSideBar: closeSideBar
            }, option.id + index);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/layout/Sidebar/index.tsx










function Sidebar(param) {
    var isOpened = param.isOpened, className = param.className, toggleDrawer = param.toggleDrawer, setOpenResource = param.setOpenResource, openResource = param.openResource;
    var dispatch = (0,hook/* useAppDispatch */.T)();
    var guideStatus = (0,hook/* useAppSelector */.C)(function(state) {
        var ref;
        return (ref = state.userGuideReducer) === null || ref === void 0 ? void 0 : ref.status;
    });
    var guideStep = (0,hook/* useAppSelector */.C)(function(state) {
        var ref;
        return (ref = state.userGuideReducer) === null || ref === void 0 ? void 0 : ref.step;
    });
    var nextStep = function() {
        dispatch((0,UserGuide/* increment */.nP)());
    };
    var closeUserGuide = function() {
        dispatch((0,UserGuide/* reset */.mc)());
    };
    var closeSideBar = function() {
        document.body.classList.add("no-hover");
        setTimeout(function() {
            document.body.classList.remove("no-hover");
        }, 1000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(className, " ").concat(guideStatus && (guideStep === 2 || guideStep === 3) ? "z-50" : "z-30", " ").concat(isOpened ? "w-[200px]" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-h-[calc(100vh-145px) relative pb-6 pt-5.25 ".concat(guideStatus && guideStep == 2 ? "z-50 bg-white" : "overflow-y-auto overflow-x-hidden"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "group-logos mx-auto h-[71px] px-5 pb-5.25",
                                onClick: function() {
                                    return closeSideBar();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex h-[50px] items-end justify-start text-center",
                                    onClick: function() {
                                        return (0,google_analytics/* trackGAEvent */.wu)("Click Logo SAPP Menu");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandIcon/* default */.Z, {
                                            type: "logo-default"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandIcon/* default */.Z, {
                                            type: "logo-full"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto mb-6 h-px w-[calc(100%-48px)] bg-gray-2 text-center"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemsList, {
                                options: Number(localStorage.getItem("countEvent")) <= 0 ? MENU_ITEMS : MENU_ITEMS.concat(MENU_ITEMS_EVENT),
                                setOpenResource: setOpenResource,
                                closeSideBar: closeSideBar
                            }),
                            guideStatus && guideStep == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupStep/* default */.Z, {
                                content: constants/* UserGuide.CONTENT_STEP_2 */.EB.CONTENT_STEP_2,
                                className: "left-full top-full ml-3 mt-3 w-screen max-w-365px",
                                index: 2,
                                total: 6,
                                handleNext: nextStep,
                                handleCancel: closeUserGuide
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute bottom-0 w-full bg-white pb-6 \n          ".concat(guideStatus && guideStep == 3 ? "z-50" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto mb-6 h-px w-[calc(100%-48px)] bg-gray-2 text-center"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemsList, {
                                options: MENU_BOTTOM,
                                setOpenResource: setOpenResource,
                                closeSideBar: closeSideBar
                            }),
                            guideStatus && guideStep == 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupStep/* default */.Z, {
                                content: constants/* UserGuide.CONTENT_STEP_3 */.EB.CONTENT_STEP_3,
                                className: "bottom-full left-full mb-3 ml-3 w-screen max-w-365px",
                                index: 3,
                                total: 6,
                                handleNext: nextStep,
                                handleCancel: closeUserGuide
                            })
                        ]
                    }),
                    guideStatus && (guideStep === 2 || guideStep === 3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 z-40 animate-fade-in-overlay bg-black opacity-55 transition-opacity"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: toggleDrawer,
                className: "sidebar-overlay ".concat(isOpened ? "block md:hidden" : "hidden", " h-ful fixed bottom-0 left-0 right-0 top-0 z-20 w-full cursor-pointer bg-overlay-dark")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LearningResource/* default */.Z, {
                open: openResource,
                setOpenResource: setOpenResource
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/contexts/PinnedNotifyContext.tsx
var PinnedNotifyContext = __webpack_require__(66268);
// EXTERNAL MODULE: ./src/contexts/index.tsx
var contexts = __webpack_require__(44446);
;// CONCATENATED MODULE: ./src/components/layout/DashboardLayout/DashboardLayout.tsx








function DashboardLayout(param) {
    var children = param.children, openDrawer = param.openDrawer;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isOpened = ref1[0], setOpened = ref1[1];
    var toggleDrawer = function() {
        return setOpened(function(prev) {
            return !prev;
        });
    };
    var ref2 = (0,PinnedNotifyContext/* usePinnedNotifyContext */.Z)(), openPinned = ref2.openPinned, pinnedNotifications = ref2.pinnedNotifications;
    var showPinnedTrial = (0,contexts/* useCourseContext */.Y)().showPinnedTrial;
    var guideStatus = (0,hook/* useAppSelector */.C)(function(state) {
        var ref;
        return (ref = state.userGuideReducer) === null || ref === void 0 ? void 0 : ref.status;
    });
    var ref3 = (0,react.useState)(false), openResource = ref3[0], setOpenResource = ref3[1];
    var isEnablePinnedPages = [
        constants/* PageLink.COURSES */.H_.COURSES,
        constants/* PageLink.USERPAGE */.H_.USERPAGE,
        constants/* PageLink.COURSE_DETAIL */.H_.COURSE_DETAIL,
        constants/* PageLink.COURSE_PART_DETAIL */.H_.COURSE_PART_DETAIL,
        constants/* PageLink.COURSE_ACTIVITY */.H_.COURSE_ACTIVITY, 
    ].includes(router.pathname);
    var paddingTop = "";
    if (isEnablePinnedPages && openPinned && (pinnedNotifications === null || pinnedNotifications === void 0 ? void 0 : (ref = pinnedNotifications.data) === null || ref === void 0 ? void 0 : ref.content)) {
        paddingTop = showPinnedTrial ? "pt-[102px]" : "pt-12";
    } else if (showPinnedTrial) {
        paddingTop = "pt-[54px]";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-nowrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {
                isOpened: isOpened,
                toggleDrawer: toggleDrawer,
                className: "menu-sidebar-left max-w-screen fixed top-0 h-screen w-20 bg-white shadow-sidebar md:left-0 ".concat(openDrawer ? "opacity-5" : "", " ").concat(guideStatus ? "" : "overflow-hidden", " ").concat(paddingTop),
                setOpenResource: setOpenResource,
                openResource: openResource
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-h-screen w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(paddingTop, " h-full bg-gray-4"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sapp-loading ml-0 ml-20 h-full",
                        children: children
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1887);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 2 modules
var icons = __webpack_require__(34648);
// EXTERNAL MODULE: ./src/utils/helpers/index.ts
var helpers = __webpack_require__(71836);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 1 modules
var modal = __webpack_require__(61611);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
// EXTERNAL MODULE: ./src/components/base/button/ButtonPrimary.tsx
var ButtonPrimary = __webpack_require__(15421);
;// CONCATENATED MODULE: ./src/components/base/modal/ModalMobile.tsx







var ModalMobile = function() {
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var accessToken = localStorage.getItem("actToken");
    var showModal = function() {
        setIsModalOpen(true);
    };
    var handleOk = function() {
        setIsModalOpen(false);
    };
    var handleCancel = function() {
        setIsModalOpen(false);
    };
    (0,react.useEffect)(function() {
        if ((0,helpers/* isMobileExtensive */.O3)()) {
            var hasSeenModal = localStorage.getItem("hasSeenMobileWarning");
            if (hasSeenModal !== "true") {
                localStorage.setItem("hasSeenMobileWarning", "true");
                showModal();
            } else if (accessToken !== localStorage.getItem("lastSeenToken")) {
                accessToken && localStorage.setItem("lastSeenToken", accessToken);
                showModal();
            }
        }
    }, [
        accessToken
    ]);
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        footer: false,
        className: "p-0",
        width: "398px",
        centered: true,
        styles: {
            content: {
                padding: 0
            }
        },
        open: isModalOpen,
        onOk: handleOk,
        onCancel: handleCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid place-items-center px-6 py-20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SadIcon */.A4, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-10 text-center text-[32px] font-semibold leading-10",
                    children: "Sorry, page is not mobile friendly"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "my-4 text-center text-gray-1",
                    children: "LMS Pro can be difficult to use on a mobile device. We are going to improve our website very soon."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPrimary/* default */.Z, {
                    title: "Continue",
                    className: "mt-10 h-10 w-[200px]",
                    onClick: handleCancel
                })
            ]
        })
    }), document.body);
};
/* harmony default export */ var modal_ModalMobile = (ModalMobile);

;// CONCATENATED MODULE: ./src/components/layout/index.tsx




// eslint-disable-next-line import/no-unused-modules
function Layout(props) {
    var children = props.children, title = props.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_ModalMobile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayout, {
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 70742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var _components_base_button_SappButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98971);



var PopupStep = function(param) {
    var content = param.content, index = param.index, total = param.total, handleNext = param.handleNext, handleCancel = param.handleCancel, _showCancel = param.showCancel, showCancel = _showCancel === void 0 ? true : _showCancel, _className = param.className, className = _className === void 0 ? "top-0 left-0" : _className, titleButtonNext = param.titleButtonNext;
    var confirmDialogRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleClose = function() {
        if (confirmDialogRef.current) {
            confirmDialogRef.current.classList.add("animate-jump-out");
            confirmDialogRef.current.classList.add("pointer-events-none");
        }
        // Remove hidden scroll when close user guide
        document.body.style.removeProperty("padding-right");
        document.body.classList.remove("overflow-hidden");
        setTimeout(function() {
            handleCancel && handleCancel();
        }, 50);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            ref: confirmDialogRef,
            className: "absolute z-50 animate-jump-in bg-primary p-7.5 ".concat(className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-base font-normal text-white",
                    children: content
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-5 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-medium-sm font-normal text-white",
                            children: [
                                index,
                                "/",
                                total
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex",
                            children: [
                                showCancel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_button_SappButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    title: "Exit",
                                    className: "px-5 py-2",
                                    size: "small",
                                    isPadding: false,
                                    childClass: "text-medium-sm",
                                    onClick: handleClose
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_button_SappButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    title: titleButtonNext ? titleButtonNext : "Next",
                                    className: "ml-3 bg-primary-3 px-5 py-2",
                                    size: "small",
                                    isPadding: false,
                                    childClass: "text-medium-sm",
                                    onClick: handleNext
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PopupStep);


/***/ }),

/***/ 66190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EQ": function() { return /* binding */ MY_COURSES; },
/* harmony export */   "ZD": function() { return /* binding */ LANG_SIGNIN; }
/* harmony export */ });
/* unused harmony exports DESCRIPTION_POPUPCONFIRM, DELETE_POPUPCONFIRM, DUPLICATE_POPUPCONFIRM, CONFIRM_STATUS_CHANGE, ACTIVE_POPUPCONFIRM, DEACTIVE_POPUPCONFIRM, REFRESH_POPUPCONFIRM */
var LANG_SIGNIN = {
    signIn: "Sign In",
    SAPPAcademy: "SAPP Academy Operations",
    signInGoogle: "Sign in with Google",
    signInApple: "Sign in with Apple",
    orWithEmail: "Or with email",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password ?",
    notMember: "Not a Member yet?",
    signUp: "Sign up",
    english: "English",
    japanese: "Japanese",
    german: "German",
    spanish: "Spanish",
    french: "French",
    terms: "Terms",
    plans: "Plans",
    contactUs: "Contact Us",
    eventTest: "Event Test"
};
var MY_COURSES = {
    explanations: "Explanations",
    hotline: "19002225",
    placeholderSearch: "Search for your course here",
    placeholderSearch3Level: "Enter name of course..."
};
var DESCRIPTION_POPUPCONFIRM = "Bạn c\xf3 chắc chắn muốn hủy kh\xf4ng?";
var DELETE_POPUPCONFIRM = "Bạn c\xf3 chắc chắn muốn x\xf3a kh\xf4ng?";
var DUPLICATE_POPUPCONFIRM = "Bạn c\xf3 chắc chắn muốn sao ch\xe9p kh\xf4ng?";
var CONFIRM_STATUS_CHANGE = "Bạn c\xf3 chắc chắn muốn đổi trạng th\xe1i kh\xf4ng?";
var ACTIVE_POPUPCONFIRM = "Bạn c\xf3 muốn k\xedch hoạt chức năng kh\xf4ng?";
var DEACTIVE_POPUPCONFIRM = "Bạn c\xf3 muốn dừng k\xedch hoạt chức năng kh\xf4ng?";
var REFRESH_POPUPCONFIRM = "Bạn c\xf3 muốn l\xe0m mới chức năng kh\xf4ng?";


/***/ })

}]);